import { call, put, takeLatest, takeEvery, all } from 'redux-saga/effects';
import api from './utils/api';
import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILED,
  UPDATE_USER_BALANCE,
  UPDATE_MY_BALANCE_SUCCESS,
  UPDATE_USER_SUCCESS,
  UPDATE_BALANCE_FAILED
} from './App/rootReducer';

// worker Saga
export function* fetchUsersSaga() {
  try {
    const response = yield call(api.fetchUsers);
    yield put({ type: FETCH_USERS_SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: FETCH_USERS_FAILED, message: e.message });
  }
}

export function* updateUserBalanceSaga(payload) {
  if (payload.balanceChange === 0) return; // Don't bother if there is no actual change

  try {
    console.log(payload);
    const response = yield call(api.updateUserBalance, payload.balanceChange, payload.userId);
    console.log(response);
    if (response.data.isOtherUser) {
      yield put({ type: UPDATE_USER_SUCCESS, updatedProfile: response.data.profile });
    } else {
      yield put({ type: UPDATE_MY_BALANCE_SUCCESS, newBalance: response.data.profile.app_metadata.balance });
    }
  } catch (e) {
    yield put({ type: UPDATE_BALANCE_FAILED, message: e.message, e });
  }
}

/* watcher Saga: Does not allow concurrent fetches. If the action gets
  dispatched while a fetch is already pending, that pending fetch is cancelled
  and only the latest one will be run.
*/
export default function* watchSagas() {
  yield all([
    yield takeLatest(FETCH_USERS_REQUEST, fetchUsersSaga),
    yield takeEvery(UPDATE_USER_BALANCE, updateUserBalanceSaga)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas.js